import { formatDay, type TaskView } from '@/lib/tasks-board'
import { TaskAlertBadge, TaskExtraBadges, TaskPriorityBadge } from './TaskBadges'

export interface TaskGroup {
  key: string
  label: string
  tasks: TaskView[]
}

interface TaskListProps {
  groups: TaskGroup[]
  onOpen: (task: TaskView) => void
  /** Mostra a coluna Responsável (vistas do escritório). */
  showResponsible?: boolean
  emptyText?: string
}

/** Lista agrupada (faixas, responsáveis ou arquivo). Clique abre a gaveta. */
export function TaskList({ groups, onOpen, showResponsible = true, emptyText = 'Nenhuma tarefa aqui.' }: TaskListProps) {
  if (groups.every((g) => g.tasks.length === 0)) {
    return <p className="py-8 text-center text-sm text-muted-foreground">{emptyText}</p>
  }
  return (
    <div className="flex flex-col gap-5">
      {groups.filter((g) => g.tasks.length > 0).map((group) => (
        <section key={group.key} aria-label={group.label}>
          <h2 className="mb-2 flex items-center gap-2 text-sm font-semibold">
            {group.label}
            <span className="tabular-nums text-muted-foreground">({group.tasks.length})</span>
          </h2>
          <ul className="divide-y rounded-md border">
            {group.tasks.map((task) => (
              <li key={task.id}>
                <button
                  type="button"
                  onClick={() => onOpen(task)}
                  className="grid w-full grid-cols-1 gap-1 px-3 py-2 text-left hover:bg-muted/50 sm:grid-cols-[1fr_auto] sm:items-center sm:gap-3"
                >
                  <span className="min-w-0">
                    <span className="block truncate font-medium">{task.title}</span>
                    <span className="block truncate text-xs text-muted-foreground">
                      {task.etapa_label}
                      {showResponsible && ` · ${task.assigned_user_name}`}
                      {task.case_number && ` · ${task.case_number}`}
                      {task.client_name && ` · ${task.client_name}`}
                    </span>
                  </span>
                  <span className="flex flex-wrap items-center gap-1.5 sm:justify-end">
                    <TaskPriorityBadge task={task} />
                    <TaskAlertBadge task={task} />
                    <TaskExtraBadges task={task} />
                    <span className="text-xs tabular-nums text-muted-foreground">{formatDay(task.data_referencia)}</span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
